export const ErrorMessage = ({error}) => {
  return <p className='error_message'>{error}</p>
}